/* eslint-disable @typescript-eslint/no-unused-vars */
import { ComponentIds, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { getEntityPosition, toggleInvisibleBoxInputEvent, runCallback, } from "../functions/dragEntity";
const { DRAG_STATE_COMPONENT } = ComponentIds;
export default class OnDragInsertSystem extends SystemBase {
    constructor() {
        super(DRAG_STATE_COMPONENT);
        this.id = "OnDragInsertSystem";
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.doingChangesOnComponent = [];
        this.mandatoryComponents = null;
        this.callback = null;
        this.oldPosition = undefined;
    }
    setCallback(callback) {
        this.callback = callback;
    }
    onAddComponent(_entity, _newComponent) {
        this.oldPosition = getEntityPosition(_newComponent);
    }
    onUpdateComponent(_entity, _oldComponent, _newComponent) { }
    onRemoveComponent(_entity, _oldComponent) {
        toggleInvisibleBoxInputEvent(_entity, _oldComponent, this.oldPosition);
        runCallback(this.callback, _oldComponent, this.oldPosition);
    }
}
